import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import TvSchedule from "./pages/TvSchedule";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/tv" element={<TvSchedule />} />
        {/* корень редиректим на /tv, если нужно */}
        <Route path="*" element={<Navigate to="/tv" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
